"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyncState = exports.needsAppNexusSync = exports.CisSyncReason = exports.serializePulseCookie = exports.parsePulseCookies = exports.cacheOldEnvironmentId = exports.eventEmitter = void 0;
/* eslint-env browser */
require("compatibility-array-includes");
var cookie_1 = require("./cookie");
var cookie_config_1 = require("./cookie-config");
var eventEmitter_1 = __importDefault(require("./eventEmitter"));
var getRootDomain_1 = require("./getRootDomain");
var PULSE_COOKIE_KEY = cookie_config_1.cookieConfig.PULSE_COOKIE_KEY, ENV_COOKIE_KEY = cookie_config_1.cookieConfig.ENV_COOKIE_KEY;
var CIS_POLL_INTERVAL = 900000; // 15 minutes
var APP_NEXUS_SYNC_INTERVAL = 14400000; // 4 hours
/**
 * Responsible for subscribing to, and emitting events.
 */
exports.eventEmitter = new eventEmitter_1.default();
function cacheOldEnvironmentId(id) {
    try {
        var envCookie = '';
        var oldIds_1 = {};
        try {
            envCookie = (0, cookie_1.readCookie)(ENV_COOKIE_KEY);
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
        try {
            oldIds_1 = envCookie ? JSON.parse(envCookie) : [];
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
        oldIds_1[id] = Date.now();
        var idsToCache = Object.keys(oldIds_1)
            .map(function (envId) { return ({ id: envId, date: oldIds_1[envId] }); })
            .sort(function (o) { return o.date; })
            .slice(0, 5)
            .reduce(function (accl, o) {
            var _a;
            return (__assign(__assign({}, accl), (_a = {}, _a[o.id] = o.date, _a)));
        }, {});
        (0, cookie_1.writeCookie)(ENV_COOKIE_KEY, JSON.stringify(idsToCache), (0, getRootDomain_1.getRootDomain)(), 365);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
}
exports.cacheOldEnvironmentId = cacheOldEnvironmentId;
function parsePulseCookies(cookie) {
    if (cookie === void 0) { cookie = (0, cookie_1.readCookie)(PULSE_COOKIE_KEY); }
    var values = decodeURIComponent(cookie).split(',');
    // Cookie is in an unknown, possibly old format. Will be ignored.
    if (values.length !== 10) {
        values = [];
    }
    var altEnvCookie = (0, cookie_1.readCookie)(ENV_COOKIE_KEY);
    var altEnvIds;
    if (altEnvIds) {
        try {
            altEnvIds = JSON.parse(altEnvCookie);
        }
        catch (e) {
            altEnvIds = undefined;
        }
    }
    return {
        environmentId: values[0],
        prevUserId: values[2] ? values[2] : undefined,
        validateAfter: values[3] ? parseInt(values[3], 10) : undefined,
        jwe: values[4],
        anId: values[5],
        syncWithAppNexus: values[6] ? parseInt(values[6], 10) : undefined,
        doTracking: values[7] ? values[7] === 'true' : undefined,
        pixelInjected: values[8] ? values[8] === 'true' : undefined,
        adId: values[9],
        altEnvIds: altEnvIds,
        visitorIdPlaceholder: values[1],
    };
}
exports.parsePulseCookies = parsePulseCookies;
function serializePulseCookie(input) {
    var _a = input || {}, _b = _a.environmentId, environmentId = _b === void 0 ? '' : _b, _c = _a.prevUserId, prevUserId = _c === void 0 ? '' : _c, _d = _a.jwe, jwe = _d === void 0 ? '' : _d, _e = _a.anId, anId = _e === void 0 ? '' : _e, _f = _a.doTracking, doTracking = _f === void 0 ? '' : _f, _g = _a.pixelInjected, pixelInjected = _g === void 0 ? '' : _g, _h = _a.adId, adId = _h === void 0 ? '' : _h, _j = _a.visitorIdPlaceholder, visitorIdPlaceholder = _j === void 0 ? 'v' : _j;
    var now = Date.now();
    var cookieString = [
        environmentId,
        visitorIdPlaceholder,
        prevUserId,
        new Date().setTime(now + CIS_POLL_INTERVAL),
        jwe,
        anId,
        anId ? new Date().setTime(now + APP_NEXUS_SYNC_INTERVAL) : 0,
        doTracking,
        pixelInjected,
        adId,
    ].join(',');
    (0, cookie_1.writeCookie)(PULSE_COOKIE_KEY, cookieString, (0, getRootDomain_1.getRootDomain)(), 2 * 365);
    exports.eventEmitter.emit('environmentIdSet', environmentId);
    exports.eventEmitter.emit('jweSet', jwe);
}
exports.serializePulseCookie = serializePulseCookie;
// TODO: Use enum if switching to typescript.
var CisSyncReason;
(function (CisSyncReason) {
    CisSyncReason["Initialize"] = "initialize";
    CisSyncReason["Login"] = "login";
    CisSyncReason["Logout"] = "logout";
    CisSyncReason["Refresh"] = "refresh";
    CisSyncReason["NewAnid"] = "new-anid";
})(CisSyncReason = exports.CisSyncReason || (exports.CisSyncReason = {}));
function needsAppNexusSync(parsedCookie, dateNow) {
    if (dateNow === void 0) { dateNow = Date.now(); }
    if ((parsedCookie.syncWithAppNexus && dateNow > parsedCookie.syncWithAppNexus) ||
        !parsedCookie.anId) {
        return true;
    }
    return false;
}
exports.needsAppNexusSync = needsAppNexusSync;
function getSyncState(userId, options) {
    if (options === void 0) { options = {}; }
    var _a = options.investigateSyncOn, investigateSyncOn = _a === void 0 ? undefined : _a, _b = options.cookie, cookie = _b === void 0 ? (0, cookie_1.readCookie)(PULSE_COOKIE_KEY) : _b;
    var parsedCookie = parsePulseCookies(cookie);
    var dateNow = Date.now();
    var syncWithAppNexus = needsAppNexusSync(parsedCookie, dateNow);
    var syncOn = function (prop) { return !investigateSyncOn || investigateSyncOn.includes(prop); };
    if (syncOn(CisSyncReason.Initialize)) {
        if (!cookie ||
            cookie.indexOf('undefined') !== -1 || // should not trigger, but what is this for?
            !parsedCookie.environmentId ||
            !parsedCookie.jwe) {
            return {
                syncWithCis: true,
                waitForCis: true,
                syncWithAppNexus: syncWithAppNexus,
                syncWithCisReason: CisSyncReason.Initialize,
            };
        }
    }
    // This case only handles login.  For example when we don't necessarily
    // have an event (tracker.update({actor: ...}) might or might not have
    // been called), then we only want to sync if we DO have a userId, and
    // if that userId is not in our cookie.
    if (syncOn(CisSyncReason.Login) && userId && String(userId) !== String(parsedCookie.prevUserId)) {
        return {
            syncWithCis: true,
            // Blocking call on login/new user to get opt out status and on logout, as SPA's rely on that state to be accurate
            // on all PPID methods after updates.
            waitForCis: true,
            syncWithAppNexus: syncWithAppNexus,
            syncWithCisReason: CisSyncReason.Login,
        };
    }
    if (syncOn(CisSyncReason.Logout) &&
        !userId &&
        String(userId) !== String(parsedCookie.prevUserId)) {
        return {
            syncWithCis: true,
            // Blocking call on login/new user to get opt out status and on logout, as SPA's rely on that state to be accurate
            // on all PPID methods after updates.
            waitForCis: true,
            syncWithAppNexus: syncWithAppNexus,
            syncWithCisReason: CisSyncReason.Logout,
        };
    }
    if (syncOn(CisSyncReason.Refresh) &&
        parsedCookie.validateAfter &&
        dateNow > parsedCookie.validateAfter) {
        return {
            syncWithCis: true,
            // Blocking call on login/new user to get opt out status, non blocking call
            // on logout to the a new JWE
            waitForCis: false,
            syncWithAppNexus: syncWithAppNexus,
            syncWithCisReason: CisSyncReason.Refresh,
        };
    }
    return {
        syncWithCis: false,
        syncWithAppNexus: syncWithAppNexus,
    };
}
exports.getSyncState = getSyncState;
//# sourceMappingURL=pulse-cookie.js.map